import { render, staticRenderFns } from "./ContactSupportBlock.vue?vue&type=template&id=2598350a&lang=pug&"
import script from "./ContactSupportBlock.vue?vue&type=script&lang=js&"
export * from "./ContactSupportBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports